import { gql } from '@grandvisionhq/graphql';
import { cartDetails } from '../fragments/cart-details.js';
import { cartValidationErrors } from '../fragments/cart-validation-errors.js';
import '../fragments/recover-inactive-cart-failure.js';
import '../fragments/recover-inactive-cart-result.js';

const REMOVE_CART_VOUCHER_CODES = gql`
  mutation RemoveCartVoucherCodes($cartInput: CartVoucherCodesInput!) {
    removeCartVoucherCodes(cartInput: $cartInput) {
      cart {
        ...CartDetailsFragment
      }
      validationErrors {
        ...CartValidationErrorsFragment
      }
      failures {
        ... on VoucherCodeNotApplicableFailure {
          cartId
          message
          code
          reason
          voucherCode
        }
        ... on UnknownCartMutationFailure {
          message
          code
        }
      }
      success
    }
  }
  ${cartDetails}
  ${cartValidationErrors}
`;

export { REMOVE_CART_VOUCHER_CODES };
//# sourceMappingURL=remove-cart-voucher-codes.js.map
